module.exports = __webpack_public_path__ + "img/title3.69913a6.png";